import AppConfig from "@/_config/application-config";
import childRoutes from "@/apps/gimo/routes/index.js";
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const namespace = "gimo";
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "GIMO",
  namespace,
  description: null,
  version: "1.1",
  icon: "mdi-alpha-r-circle-outline",
  parentRoute: "/gimo",
  accentColor: "red",
  childRoutes,
  defaultRoute: "ChooseOperation", // "allmysurveys",
  component: () => import("@/apps/gimo/Application.vue"),
  settings: {
    // api_url: "https://as-gimoapi-dev.azurewebsites.net/api/",
    // client_id: "1051483b-f7ae-4f56-9e72-caa8a708c519",
    // scope: "api://1051483b-f7ae-4f56-9e72-caa8a708c519/f8144895-f0bf-453a-b1af-56aabc299746",
    // authorize_url: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    // token_url: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    // logout_url: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080",
    // // STAGE
    // api_url: "https://as-gimoapi-stg.azurewebsites.net/",
    // client_id: "d9fa34dc-c004-4bd3-8d69-89abb343df5b",
    // scope: "api://d9fa34dc-c004-4bd3-8d69-89abb343df5b/Read.All",
    // DEV
    // api_url: "https://api.nonprd.lyb.com/external/gimo-dev/api/",
    // client_id: "513e9db7-79bb-4a20-aa09-0f417ed25740",
    // scope: "api://513e9db7-79bb-4a20-aa09-0f417ed25740/Read.All",
    // authorize_url:
    //   "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    // token_url:
    //   "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    // logout_url:
    //   "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080",
    //PRD
    api_url: "https://as-gimoapi-prd.azurewebsites.net/",
    client_id: "cd31724b-d289-4d5a-ba95-f9fd1088ee85",
    scope: "api://cd31724b-d289-4d5a-ba95-f9fd1088ee85/Read.All",
    authorize_url:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    token_url:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logout_url:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080",
    redirect_uri: window.location.origin, //Gets the current
    autologin: true,
    debug: false,
    currentTime: null,
    currentTimeInterval: null,
    //azure_deployed: 1,
    navigation: [
      // {
      //   icon: "mdi-view-list-outline",
      //   text: "Vendor Management",
      //   link: "/gimo/vendormanagement",
      //   roles: ["SuperAdmin"],
      // },
      // {
      //   icon: "mdi-account-multiple-outline",
      //   text: "User Management",
      //   link: "/gimo/usermanagement",
      //   roles: ["SuperAdmin"],
      // },
      // {
      //   icon: "mdi-application-edit-outline",
      //   text: "Edit Template",
      //   link: "/gimo/edittemplate",
      //   roles: ["SuperAdmin"],
      // },
      // {
      //   icon: "mdi-format-list-numbered",
      //   text: "Survey Tracking",
      //   link: "/gimo/surveytracking",
      //   roles: ["SuperAdmin", "CategoryManager"],
      // },
      // {
      //   icon: "mdi-application-edit-outline",
      //   text: "Create New Survey",
      //   link: "/gimo/createnewsurvey",
      //   roles: ["SuperAdmin", "CategoryManager"],
      // },
      // {
      //   icon: "mdi-format-list-numbered",
      //   text: "All My Surveys",
      //   link: "/gimo/allmysurveys",
      //   roles: ["SuperAdmin", "CategoryManager", "Stakeholder", "Supplier"],
      // },
    ],
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    userInfo: {
      default: null,
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  },
};

export default AppConfig.merge(appConfig);
